import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { MeService } from '@shared/services/me.service';
import { NavigationService } from '@userProfile/services/navigation.service';

@Injectable({
  providedIn: 'root',
})
export class IsHermesUserGuard implements CanActivate {
  constructor(
    private meService: MeService,
    private navigationService: NavigationService,
  ) {}

  handleHarpAccessCheck(isHermesUser) {
    if (isHermesUser) {
      return true;
    } else {
      this.navigationService.goToHome();
      return false;
    }
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.meService.getHarpAccessControl().pipe(
      map(({ isHermesUser }: any) => this.handleHarpAccessCheck(isHermesUser)),
      catchError(({ error }: any) => {
        const { isHermesUser } = error;
        return of(this.handleHarpAccessCheck(isHermesUser));
      }),
    );
  }
}
